// Function to format date for input and submission (YYYY-MM-DD format)
export const formatDate = (date) => {
    if (!date) return ""; // Handle null or undefined values
    
    const parsedDate = new Date(date);
    
    if (isNaN(parsedDate.getTime())) {
      console.error("Invalid date:", date); // Log invalid values for debugging
      return "";
    }
  
    return parsedDate.toISOString().split("T")[0]; // Format to YYYY-MM-DD
  };

  // Function to display date in DD/MM/YYYY format
  export const displayDate = (date) => {
    if (!date) return ""; // Handle null or undefined values
    
    const parsedDate = new Date(date);
    
    if (isNaN(parsedDate.getTime())) {
      console.error("Invalid date:", date); // Log invalid values for debugging
      return "";
    }
  
    const day = String(parsedDate.getDate()).padStart(2, '0');
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const year = parsedDate.getFullYear();
    return `${day}/${month}/${year}`; // Return date as DD/MM/YYYY
  };

  // This will safely convert all DD/MM/YYYY strings into YYYY-MM-DD
  export const convertToInputDate = (dateStr) => {
    if (!dateStr) return "";
    const [day, month, year] = dateStr.split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };
  
  export const formatDateWithOrdinal = (inputDate) => {
    if (!inputDate) return '';
  
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
  
    // Function to get ordinal suffix
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return 'th'; // covers 11th–13th
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    };
  
    return `${day}${getOrdinal(day)} ${month} ${year}`;
  };
  
  export const calculateExperience = (inputDate) => {
    const joiningDate = new Date(inputDate);
    const currentDate = new Date();
  
    // Calculate the difference in years, months, and days
    let years = currentDate.getFullYear() - joiningDate.getFullYear();
    let months = currentDate.getMonth() - joiningDate.getMonth();
    let days = currentDate.getDate() - joiningDate.getDate();
  
    // Adjust for months and years
    if (months < 0) {
      years--;
      months += 12;
    }
  
    // Adjust for days
    if (days < 0) {
      months--;
      const lastMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
      days += lastMonth.getDate();
    }
  
    // Calculate total days and weeks
    const totalDays = Math.floor((currentDate - joiningDate) / (1000 * 60 * 60 * 24));
    const weeks = Math.floor(totalDays / 7);
  
    // Format the output based on the most appropriate unit
    if (years > 0) {
      return `${years}+ years of experience`;
    } else if (months > 0) {
      return `${months} months of experience`;
    } else if (weeks > 0) {
      return `${weeks} weeks of experience`;
    } else {
      return `${days} days of experience`;
    }
  };
  
  export function formatTimeZoneDate(date) {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  }